<template>
    <div class="container-404" :style="defaultHeight">
        <h1>未授权或已过期！</h1>

        <div class="text">请登录后操作。</div>
        <div>
            <el-button type="danger" icon="el-icon-s-home" round @click="goHome">立即登录</el-button>
        </div>
    </div>
</template>

<script>
    import {onBeforeMount, reactive, toRefs} from "vue"

    export default {
        setup() {
            const state = reactive({
                defaultHeight: {
                    height: ''
                }
            })

            onBeforeMount(() => {
                state.defaultHeight.height = document.body.clientHeight + "px"
            })

            const goHome = () => {
                window.location.href="http://admin.bg.ciprun.com/admin"
            }

            return {
                ...toRefs(state),
                goHome,
            }
        }
    }
</script>

<style lang="less">
    .container-404 {
        height: 100%;
        margin: 0 auto;
        padding-top: 15%;
        text-align: center;
        color: #494b52;
        background: #17191c;
        font-weight: 400;
        font-family: "Raleway", sans-serif;
        font-size: 15px;
        letter-spacing: 0.3px;

        .text {
            margin-bottom: 0.5em;
        }

        .team {
            margin: 1.2em 0;
        }

        a {
            text-decoration: none;
            color: #007bff;
        }
    }
</style>